import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { Trans } from '@lingui/react/macro'
import { ButtonFilled } from '@vgw/multibrand-fe-button'
import { LockPagesLayout } from '@/routes/-lock-pages-layout'
import { getAccountCapabilities } from '@/features/ctrls-and-caps/get-account-capabilities'
import { getBrandConfig } from '@/config/config'

export const Route = createFileRoute('/_app/verification-required')({
  component: RouteComponent,
  beforeLoad: async () => {
    const { canPlay } = await getAccountCapabilities()

    if (canPlay) {
      throw redirect({ to: '/' })
    }
  },
})

function RouteComponent() {
  const { name: brandName } = getBrandConfig()

  return (
    <LockPagesLayout>
      <div className="w-full">
        <header data-testid="self-exclusion-header">
          <h1 className="mb-3 text-center text-xl font-bold">
            <Trans>Verification Required</Trans>
          </h1>
          <p className="mb-4 text-center font-body text-base leading-6">
            <Trans>
              As part of our ongoing compliance requirements, we need to verify
              your identity.
            </Trans>
          </p>
          <p className="mb-4 text-center font-body text-base leading-6">
            <Trans>Verify now to continue playing in {brandName}.</Trans>
          </p>

          <ButtonFilled asChild>
            <Link to="/account-verification">
              <Trans>Verify account</Trans>
            </Link>
          </ButtonFilled>
        </header>
      </div>
    </LockPagesLayout>
  )
}
